var link_preview_default = {
  "fontElementMap": "KT1yD",
  "linkPreviewContainer": "Eomcw",
  "linkPreview": "hiPPV",
  "linkPreviewImage": "IeEgX",
  "linkPreviewInfo": "NSHys",
  "linkPreviewTitle": "GliV-",
  "linkPreviewDescription": "qzni2",
  "linkPreviewUrl": "G0yj-"
};
export {
  link_preview_default as default
};
//# sourceMappingURL=link-preview-scss.js.map
